@import '../../styles/modals.css';
@import '../../styles/buttons.css';
@import '../../styles/form.css';


:host .tambr-modal-window {
  background-color: #f8f9fa;
}

:host .tambr-modal-window {
  background-color: #f8f9fa;
}

:host .tambr-form-item{
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
}

.tambr-form-item textarea {
  width: 100%;
  height: 150px;
  padding: 12px 15px;
  box-sizing: border-box;
  border: 1px solid #d5d9de;
  border-radius: 4px;
  background-color: #fff;
  font-size: 14px;
  resize: none;
  font-family: inherit;
  color: #555;
  letter-spacing: 0.6px;
}

.tambr-form-item textarea:focus {
  outline: none; 
}

.tambr-form-item textarea::placeholder {
  opacity: 0.4;
  font-size: 14px;
  color: #555;
  letter-spacing: 0.6px;
  font-family: inherit;
}

.notes-status{
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #a0a5ab;
  font-size: 12px;
  padding: 5px;
}

.clear-btn {
  padding: 0;
  align-self: flex-end;
  color: #a0a5ab;
  font-size: 12px;
}